const html = require('choo/html')

const {
  drums, effects, loops, voice, chords, notes, add, exportPack, playCircle
} = require('./icons.js')
const { Button } = require('./elements.js')

module.exports = function SoundLibrary(state, emit) {
  function SoundLibraryItem(sample) {
    function onClick() {
      emit('previewsample', sample.id)
      if (state.selectedSample === sample.id) {
        emit('deselectsample')
      } else {
        emit('selectsample', sample.id)
      }
    }
    return html`
      <li class="size-big" draggable="true" data-mine="${!!sample.mySample}" data-file=${sample.id}>
        ${Button( {
          onClick: onClick,
          active: state.selectedSample === sample.id
        },
          html`
            <span class="play">${playCircle()}</span>
            <span class="sound">${sample.name}</span>
          `
        )}
      </li>
    `
  }

  const soundLibraryHidden = state.isSoundLibraryOpen ? 'visible' : 'hidden'
  const mySamples = state.samples.filter(s => s.mySample)
  const defaultSamples = state.samples.filter(s => !s.mySample)
  let soundList = null
  if (mySamples.length === 0) {
    soundList = defaultSamples.map(SoundLibraryItem)
  } else {
    soundList = html`
      <li class="list-title">My Sounds</li>
      ${mySamples.map(SoundLibraryItem)}
      <li class="list-title">Default Sounds</li>
      ${defaultSamples.map(SoundLibraryItem)}
    `
  }

  return html`
    <div id="sound-library" class="contour space-tight ${soundLibraryHidden}">
      <ul id="sound-list" class="space-default">
        ${soundList}
      </ul>
      <ul id="sound-library-controls" class="row space-small align-center">
          <li id="import" class="size-big square">
            ${Button(
              { onClick: () => emit('openfilepicker') },
              html`<span>${add}</span>`
            )}
          </li>
      </ul>
    </div>
  `
}
